"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureContext_1 = require("../feature/FeatureContext");
var InMemoryFeatureStorage = /** @class */ (function () {
    function InMemoryFeatureStorage(records) {
        this.storage = new Map(records);
    }
    InMemoryFeatureStorage.prototype.getRecord = function (featureContext) {
        return this.storage.get((0, FeatureContext_1.stringifyFeatureContext)(featureContext));
    };
    return InMemoryFeatureStorage;
}());
exports.default = InMemoryFeatureStorage;
